// @flow
export const CARD_TYPE_ANONYMOUS = 'Acard'
export const CARD_TYPE_PERSONAL = 'Pcard'
export const CARD_TYPE_INTERVENTION = 'Icard'
export const CARD_TYPE_UNKNOWN = ''

export type CardType = 'Acard' | 'Pcard' | 'Icard' | ''



// WEBPACK FOOTER //
// ./src/types/card-type.js